import React from 'react';
import styled, { keyframes } from 'styled-components';

const PageContainer = styled.div`
  text-align: center;
  padding: 20px;
  background: #D1CDC8;
  min-height: 100vh;
  display: flex;
  justify-content: center;
  align-items: center;
`;

const spin = keyframes`
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
`;

const Spinner = styled.div`
  border: 8px solid #f3f3f3;
  border-top: 8px solid #E7E6E4;;
  border-radius: 50%;
  width: 60px;
  height: 60px;
  animation: ${spin} 2s linear infinite;
`;

function Loading() {
  return (
    <PageContainer>
      <Spinner />
    </PageContainer>
  );
}

export default Loading;